import React from 'react';
import './Button.css';

// Accepts both the old size names (small/medium/large) and Bootstrap's (sm/md/lg)
const SIZE_CLASS = {
  small: 'sm',
  sm: 'sm',
  medium: 'md',
  md: 'md',
  large: 'lg',
  lg: 'lg',
};

/**
 * The app-wide button. Use this instead of react-bootstrap's <Button> or a
 * raw <button> so every button looks and behaves the same.
 *
 * variant: primary | secondary | success | danger | warning | info | light |
 *          dark | link | outline-<any of the colours>
 * size:    sm | md | lg  (small | medium | large also work)
 * loading: shows a spinner and disables the button
 * icon / iconRight: an icon element shown before / after the label
 * block:   full width
 * Any other prop (title, id, name, form, aria-*, style, ...) is passed through.
 */
const Button = ({
  type = 'button',
  onClick,
  disabled = false,
  className = '',
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  icon = null,
  iconRight = null,
  block = false,
  ...rest
}) => {
  const classNames = [
    'btn',
    `btn-${variant}`,
    `btn-${SIZE_CLASS[size] || 'md'}`,
    block ? 'btn-block-full' : '',
    loading ? 'btn-loading' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={classNames}
      {...rest}
    >
      {loading ? (
        <span className="btn-spinner" aria-hidden="true" />
      ) : (
        icon && <span className="btn-icon" aria-hidden="true">{icon}</span>
      )}
      {children}
      {iconRight && !loading && (
        <span className="btn-icon" aria-hidden="true">{iconRight}</span>
      )}
    </button>
  );
};

export default Button;
